var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{key:_vm.marker.number,attrs:{"lat-lng":[_vm.marker.lat, _vm.marker.lng],"options":_vm.leafletMarkerOptions}},[_c('l-icon',{ref:"icon"},[_c('router-link',{ref:"marker",staticClass:"marker",class:_vm.$route.params.slug === _vm.marker.slug ? 'opened' : '',attrs:{"to":{
        name: 'liste-entreprises',
        params: {
          slug: _vm.marker.slug,
        },
      }}},[_vm._v(" "+_vm._s(_vm.marker.number)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }